import './scss/theme.scss';
import naja from 'naja';
import jQuery from "jquery";
import replaceEspecialChars from './js/utils.js';
import {mainExtension} from './js/spinner.js';

window.$ = window.jQuery = jQuery;

naja.initialize();

naja.registerExtension(mainExtension);

var part = null;

naja.uiHandler.addEventListener('interaction', (event) => {
  if (event.detail.element.hasAttribute('data-spinner-target')) {
    event.detail.options.spinner = event.detail.element.getAttribute('data-spinner-target');
  }
  if (event.detail.element.hasAttribute('data-part')) {
    console.log(event.detail.element.dataset['part']);
    part = event.detail.element.dataset['part'];
    var goal = $('#' + part).position().top - 20;
    var aim = goal + $('#snippet--mainCnt').scrollTop();
    $("#snippet--mainCnt").scrollTop(aim);
  }
  else {
    $("#snippet--mainCnt").scrollTop(0);
  }
});


$(document).on("keyup", "#search", function () {
  var word = replaceEspecialChars($(this).val());
  if ($(".sidebar-menu li[data-i^='" + word + "']:first").html() !== '') {
    var goal = $(".sidebar-menu li[data-i^='" + word + "']:first").position().top - 86;
    var aim = goal + $('#snippet--menuCnt').scrollTop();
    $("#snippet--menuCnt").scrollTop(aim);
  }
});

$(document).on('click','.play-snd',function(e){    
  e.preventDefault();
  var el = $(this);
  if(!$(this).hasClass("played")) {
    //el.addClass("played fa-spinner fa-spin").removeClass("play-snd fa-volume-up");
    var lang=$(this).data('lang');
    var type=$(this).data('type');
    var i=0;
    var list = $(this).data("snd").split(',');      
    var audio = new Audio('/sound/'+type+'/'+lang+'/'+list[i++]+".ogg");      
    audio.play();  

    audio.onplay = function() {      
      el.addClass("played fa-spinner fa-spin").removeClass("play-snd fa-volume-up");
    }
    audio.onended = function() {
      if(i<list.length) {
        audio = new Audio('/sound/'+type+'/'+lang+'/'+list[i++]+".ogg");        
        audio.play();
        audio.onplay = function() {          
          el.addClass("played fa-spinner fa-spin").removeClass("play-snd fa-volume-up");
        };
        audio.onended = function() {
          el.addClass("play-snd fa-volume-up").removeClass("fa-spinner fa-spin played");    
        };
      }
      el.addClass("play-snd fa-volume-up").removeClass("fa-spinner fa-spin played");    
    };   
  }        
});

console.log("ready");